import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@workboard/wobo-ui';
import styled from 'styled-components';

const DEFAULT_MESSAGE = 'Are you sure you want to delete this key result? This cannot be undone.';
const DEFAULT_SUB_CASCADE_KR_COUNT = 0;

type CascadeKrDeleteModalProps = {
  onClose: () => void;
  onSubmit: () => void;
  subCascadeKrCount?: number;
};

const StyledModal = styled(Modal)`
  z-index: 1000001 !important;
`;

export const CascadeKrDeleteModal = ({
  subCascadeKrCount = DEFAULT_SUB_CASCADE_KR_COUNT,
  onClose,
  onSubmit,
}: CascadeKrDeleteModalProps) => {
  const { t } = useTranslation();
  let line1 = '';
  if (subCascadeKrCount > 0) {
    const part1 = t('This key result has at least');
    const part2 = t('other results nested under it, this operation will delete all of them.');
    line1 = `${part1} ${subCascadeKrCount} ${part2}`;
  }
  // remove the text after question mark
  const line2 = `${t(DEFAULT_MESSAGE).split('?')[0]}?`;
  return (
    <StyledModal
      isOpen
      title={t('Delete Key Result')}
      onDismiss={onClose}
      onSubmit={onSubmit}
      submitLabel={t('Delete Key Result')}
      isDanger
    >
      {line1 && <p>{line1}</p>}
      <p>{line2}</p>
    </StyledModal>
  );
};
